import { Box, Icon, IconButton, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Delete } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";
import CellLink from "../HOC/CustomComponents/CellLink";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import ShipmentRegion from "../HOC/CustomComponents/ShipmentRegion";
import CustomSpinner from "../HOC/FunctionComponents/CustomSpinner";

const PREFIX = "useManifestDetails";

const classes = {
  iconColor: `${PREFIX}-iconColor`,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  [`& .${classes.iconColor}`]: {
    color: theme.palette.success.main,
  },
}));

const useWarehouseManifestDetails = ({
  type,
  approved,
  pickedProduct,
  setPickedProduct: removeProduct,
  saveManifestLoad,
}) => {
  const { t } = useTranslation();


  const deleteProduct = (manifestProduct) => (
    <FixedTableCell component="th" scope="row">
      <IconButton
        size="small"
        disabled={approved || saveManifestLoad}
        onClick={() => {
          pickedProduct.products.forEach((i) => {
            if (i.product.id === manifestProduct.product.id) {
              i["pendingDelete"] = true;
            }
          });
          removeProduct((prev) => ({
            products: pickedProduct.products,
          }));
        }}
      >
        {manifestProduct["pendingDelete"] ? (
          <CustomSpinner name="ClockLoader" size={20} />
        ) : (
          <Delete />
        )}
      </IconButton>
    </FixedTableCell>
  );

  /* --------------------------------- PADD --------------------------------- */

  const paddTableHead = [
    "#",
    "product",
    "wareHouse",
    "quantity",
    removeProduct ? "" : null,
  ];

  const paddTableBody = (manifestProducts, index) => {
    const toBeCollected = 0
    // manifestShipment?.shipment?.paymentType?.code === "CASH" ||
    // manifestShipment?.shipment?.type?.code === "RTS"
    //   ? manifestShipment?.shipment?.type?.code === "RTS"
    //     ? manifestShipment?.shipment?.totalAmount
    //     : manifestShipment?.shipment?.allDueFees
    //   : 0;
    return (
      <StyledTableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={manifestProducts?.product.id}
      >
        <FixedTableCell>{index + 1}</FixedTableCell>
        <CellLink pathname={`/admin/products/${manifestProducts?.product?.id}`}>
          <Box
            component="span"
            fontWeight="bold"
          >{` (${manifestProducts?.product?.code}) `}</Box>
          <Box component="span">{manifestProducts?.product?.name}</Box>
        </CellLink>
        <CellLink
          pathname={`/admin/warehouse/${manifestProducts?.section?.id}`}
        >
          {manifestProducts?.section?.name}
        </CellLink>
        <FixedTableCell>
          {manifestProducts?.quantity}
        </FixedTableCell>
        {removeProduct && deleteProduct(manifestProducts)}
      </StyledTableRow>
    );
  };

  const paddTableTotal = {
    quantity: 0,
  };
  /* --------------------------------- PRTRN --------------------------------- */

  const prtrnTableHead = [
    "#",
    "product",
    "quantity",
    removeProduct ? "" : null,
  ];

  const prtrnTableBody = (manifestProducts, index) => {
    const toBeCollected = 0
    // manifestShipment?.shipment?.paymentType?.code === "CASH" ||
    // manifestShipment?.shipment?.type?.code === "RTS"
    //   ? manifestShipment?.shipment?.type?.code === "RTS"
    //     ? manifestShipment?.shipment?.totalAmount
    //     : manifestShipment?.shipment?.allDueFees
    //   : 0;
    return (
      <StyledTableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={manifestProducts?.product.id}
      >
        <FixedTableCell>{index + 1}</FixedTableCell>
        <CellLink pathname={`/admin/products/${manifestProducts?.product?.id}`}>
          <Box
            component="span"
            fontWeight="bold"
          >{` (${manifestProducts?.product?.code}) `}</Box>
          <Box component="span">{manifestProducts?.product?.name}</Box>
        </CellLink>
        <FixedTableCell>
          {manifestProducts?.quantity}
        </FixedTableCell>
        {removeProduct && deleteProduct(manifestProducts)}
      </StyledTableRow>
    );
  };

  const prtrnTableTotal = {
    quantity: 0,
  };
  /* --------------------------------- PMBT --------------------------------- */

  const pmbtTableHead = [
    "#",
    "product",
    "quantity",
    removeProduct ? "" : null,
  ];

  const pmbtTableBody = (manifestProducts, index) => {
    const toBeCollected = 0
    // manifestShipment?.shipment?.paymentType?.code === "CASH" ||
    // manifestShipment?.shipment?.type?.code === "RTS"
    //   ? manifestShipment?.shipment?.type?.code === "RTS"
    //     ? manifestShipment?.shipment?.totalAmount
    //     : manifestShipment?.shipment?.allDueFees
    //   : 0;
    return (
      <StyledTableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={manifestProducts?.product.id}
      >
        <FixedTableCell>{index + 1}</FixedTableCell>
        <CellLink pathname={`/admin/products/${manifestProducts?.product?.id}`}>
          <Box
            component="span"
            fontWeight="bold"
          >{` (${manifestProducts?.product?.code}) `}</Box>
          <Box component="span">{manifestProducts?.product?.name}</Box>
        </CellLink>
        <FixedTableCell>
          {manifestProducts?.quantity}
        </FixedTableCell>
        {removeProduct && deleteProduct(manifestProducts)}
      </StyledTableRow>
    );
  };

  const pmbtTableTotal = {
    quantity: 0,
  };
  /* --------------------------------- PMBR --------------------------------- */

  const pmbrTableHead = [
    "#",
    "product",
    "wareHouse",
    "quantity",
    removeProduct ? "" : null,
  ];

  const pmbrTableBody = (manifestProducts, index) => {
    const toBeCollected = 0
    // manifestShipment?.shipment?.paymentType?.code === "CASH" ||
    // manifestShipment?.shipment?.type?.code === "RTS"
    //   ? manifestShipment?.shipment?.type?.code === "RTS"
    //     ? manifestShipment?.shipment?.totalAmount
    //     : manifestShipment?.shipment?.allDueFees
    //   : 0;
    return (
      <StyledTableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={manifestProducts?.product.id}
      >
        <FixedTableCell>{index + 1}</FixedTableCell>
        <CellLink pathname={`/admin/products/${manifestProducts?.product?.id}`}>
          <Box
            component="span"
            fontWeight="bold"
          >{` (${manifestProducts?.product?.code}) `}</Box>
          <Box component="span">{manifestProducts?.product?.name}</Box>
        </CellLink>
        <CellLink
          pathname={`/admin/warehouse/${manifestProducts?.section?.id}`}
        >
          {manifestProducts?.section?.name}
        </CellLink>
        <FixedTableCell>
          {manifestProducts?.quantity}
        </FixedTableCell>
        {removeProduct && deleteProduct(manifestProducts)}
      </StyledTableRow>
    );
  };

  const pmbrTableTotal = {
    quantity: 0,
  };
  /* --------------------------------- Manifests Object --------------------------------- */

  const manifestsObject = {
    PADD: {
      id: "1",
      customer: true,
      // sumTableNumber: null,
      label: t("receiveProductFromCustomer"),
      tableHead: paddTableHead,
      tableBody: paddTableBody,
      tableTotal: paddTableTotal,
      sumTableNumber: (product, tableTotal) => {
        Object.entries(tableTotal).forEach(([k, v]) => {
          tableTotal[k] += product?.[k] ?? 0;
        });
      },
    },
    PMBT: {
      id: "2",
      customer: false,
      // sumTableNumber: null,
      label: t("sendProductTransfer"),
      tableHead: pmbtTableHead,
      tableBody: pmbtTableBody,
      tableTotal: pmbtTableTotal,
      sumTableNumber: (product, tableTotal) => {
        Object.entries(tableTotal).forEach(([k, v]) => {
          tableTotal[k] += product?.[k] ?? 0;
        });
      },
    },
    PMBR: {
      id: "3",
      customer: false,
      // sumTableNumber: null,
      label: t("receiveProductTransfer"),
      tableHead: pmbrTableHead,
      tableBody: pmbrTableBody,
      tableTotal: pmbrTableTotal,
      sumTableNumber: (product, tableTotal) => {
        Object.entries(tableTotal).forEach(([k, v]) => {
          tableTotal[k] += product?.[k] ?? 0;
        });
      },
    },
    PRTRN: {
      id: "4",
      customer: true,
      // sumTableNumber: null,
      label: t("returnProductToCustomer"),
      tableHead: prtrnTableHead,
      tableBody: prtrnTableBody,
      tableTotal: prtrnTableTotal,
      sumTableNumber: (product, tableTotal) => {
        Object.entries(tableTotal).forEach(([k, v]) => {
          tableTotal[k] += product?.[k] ?? 0;
        });
      },
    }
  };

  return {
    details: manifestsObject[type],
  };
};

export default useWarehouseManifestDetails;
